import { render, staticRenderFns } from "./Nacionalidades.vue?vue&type=template&id=0b827c72&"
import script from "./Nacionalidades.vue?vue&type=script&lang=js&"
export * from "./Nacionalidades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports